import React from "react";

import { NoResults } from "./index.styles";

export default () => <NoResults>No results found</NoResults>;
